<app-search-wrap
  [persistent]="true"
  (open)="openSearch()"
  (close)="closeSearch()"
  (onSearch)="search($event)"
  [title]="i18n.instant('home.fridges')"
></app-search-wrap>

<div class="status-filters">
  <button
    class="status-filters__btn"
    [class.active]="statusFilter === 'all'"
    (click)="setStatusFilter('all')"
  >{{ 'home.filter_all' | translate }}</button>
  <button
    class="status-filters__btn"
    [class.active]="statusFilter === 'online'"
    (click)="setStatusFilter('online')"
  >{{ 'home.filter_online' | translate }}</button>
  <button
    class="status-filters__btn"
    [class.active]="statusFilter === 'offline'"
    (click)="setStatusFilter('offline')"
  >{{ 'home.filter_offline' | translate }}</button>
</div>

@if (fridgeList) {
  <div class="fridge-list">
    @for (bucket of buckets; track bucket.key) {
      <div class="fridge-group">
        <div class="fridge-group__header" (click)="toggleBucket(bucket.key)">
          <span class="dot" [class.green]="bucket.key === 'online'" [class.red]="bucket.key === 'offline'" [class.orange]="bucket.key === 'stopSale'"></span>
          @switch (bucket.key) {
            @case ('online') { {{ 'home.online' | translate }} }
            @case ('offline') { {{ 'home.offline' | translate }} }
            @case ('stopSale') { {{ 'home.stop_sale_group' | translate }} }
          }
          ({{ bucket.count }})
          <span class="fridge-group__toggle">{{ collapsed[bucket.key] ? '▾' : '▴' }}</span>
        </div>
        @if (!collapsed[bucket.key]) {
          @if (bucket.sections) {
            @for (section of bucket.sections; track section.key) {
              <div class="fridge-section">
                <div class="fridge-section__title">{{ section.label }}</div>
                @for (item of section.items; track item.install._id) {
                  <app-fridge-list
                    [fridge]="item.install"
                    [showMerchant]="item.showMerchant"
                    (selectFridge)="select.emit($event)"
                  ></app-fridge-list>
                }
              </div>
            }
          } @else {
            @for (item of bucket.items; track item.install._id) {
              <app-fridge-list
                [fridge]="item.install"
                [showMerchant]="item.showMerchant"
                (selectFridge)="select.emit($event)"
              ></app-fridge-list>
            }
          }
        }
      </div>
    }
    @if (!buckets.length) {
      <div class="fridge-list__empty">{{ 'home.no_fridges' | translate }}</div>
    }
    @if (hiddenStaleCount) {
      <div class="fridge-list__hidden">{{ 'home.hidden_stale' | translate: { count: hiddenStaleCount } }}</div>
    }
  </div>
}
